import script from "./BrethrenHero.vue?vue&type=script&setup=true&lang=js"
export * from "./BrethrenHero.vue?vue&type=script&setup=true&lang=js"

import "./BrethrenHero.vue?vue&type=style&index=0&id=77bd786b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77bd786b"]])

export default __exports__